<template>
  <AppButton variant="tertiary" size="sm" icon-only aria-label="Toggle favorite"
    @click="toggleFavorite({ id: favoritable.id, type: favoritable.type, favoritable_id: favoritable.id, favoritable_type: `App\\Models\\${favoritable.type}` })">
    <svg xmlns="http://www.w3.org/2000/svg" :fill="isFavorite ? 'currentColor' : 'none'" viewBox="0 0 24 24"
      stroke-width="1.5" stroke="currentColor" class="size-[18px] shrink-0" :style="favoriteIconStyle">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
    </svg>
  </AppButton>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { useFavoritesStore } from '@/stores/favorites'

export default {
  name: 'FavoriteButton',
  props: {
    favoritable: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useFavoritesStore, ['favorites']),
    isFavorite() {
      return this.favorites.some(f => f?.favoritable?.id === this.favoritable.id && f?.type === this.favoritable.type)
    },
    favoriteIconStyle() {
      return {
        color: this.isFavorite ? 'var(--team-color)' : 'rgb(156 163 175)',
        filter: this.isFavorite ? 'drop-shadow(0 0 6px rgba(var(--team-color-rgb), 0.35))' : 'none',
      }
    },
  },
  methods: {
    ...mapActions(useFavoritesStore, ['toggleFavorite']),
  },
}
</script>
